// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","foot":"Footer_foot__57jc1"};